import { useForgotPassword } from '../api/queries';

/** La richiesta del link di reset: il server risponde allo stesso modo per ogni email. */
export function useForgotPasswordScreen() {
  const forgotPassword = useForgotPassword();

  return {
    submitting: forgotPassword.isPending,
    error: forgotPassword.error?.message,
    sent: forgotPassword.isSuccess,
    submit: (email: string) => forgotPassword.mutate(email.trim()),
  };
}
